const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "province":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "province",
    reducer: reducer,
};

export default data;